export class DisbursementOverpayment {
  id: number | string;
  user_id: number | string;
  category: string;
  amount: number;
  action?: string;
}
